import { defineStore } from 'pinia'
import { ref } from 'vue'

interface SuccessButton {
  text: string
  preset?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger'
  icon?: string
  action: () => void
}

interface SuccessConfig {
  title?: string
  message?: string
  icon?: string
  details?: string
  detailsTitle?: string
  buttons?: SuccessButton[]
}

export const useSuccessMessageStore = defineStore('successMessage', () => {
  const showSuccessModal = ref(false)
  const title = ref('Operation Successful!')
  const message = ref('Your operation has been completed successfully.')
  const icon = ref('check_circle')
  const details = ref('')
  const detailsTitle = ref('Details')
  const buttons = ref<SuccessButton[]>([])

  function showSuccess(config: SuccessConfig = {}) {
    title.value = config.title || 'Operation Successful!'
    message.value = config.message || 'Your operation has been completed successfully.'
    icon.value = config.icon || 'check_circle'
    details.value = config.details || ''
    detailsTitle.value = config.detailsTitle || 'Details'
    buttons.value = config.buttons || []

    showSuccessModal.value = true
  }

  function hideSuccess() {
    showSuccessModal.value = false
  }

  return {
    showSuccessModal,
    title,
    message,
    icon,
    details,
    detailsTitle,
    buttons,
    showSuccess,
    hideSuccess,
  }
})
